import { ReactNode } from 'react'

import IconButton from '@components/IconButton/IconButton'
import { faXmark } from '@fortawesome/pro-solid-svg-icons'
import { DialogTitle as MUIDialogTitle, SxProps } from '@mui/material'

type Props = {
	onClose: () => void
	children: ReactNode
	sx?: SxProps
}

/**
 * Wrapper for MUI DialogTitle that adds a close button
 */
export default function DialogTitle({ onClose, children, ...rest }: Props) {
	return (
		<MUIDialogTitle noWrap sx={{ overflow: 'hidden' }} width="90%" variant="h6" {...rest}>
			<>
				{children}
				{onClose && (
					<IconButton
						aria-label="close"
						onClick={onClose}
						icon={faXmark}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
						}}
						data-testid="dialog-close"
					/>
				)}
			</>
		</MUIDialogTitle>
	)
}
